import React from "react";

function EditIcon({ className }: { className: string }) {
  return (
    <svg className={className} viewBox="0 0 19.171 19.174">
      <path
        d="M6.935,16.776,2.586,12.427l10.52-10.52,4.349,4.349ZM2.179,13.193l3.99,3.99L.188,19.175ZM18.793,4.924l-.754.754L13.683,1.324l.754-.754a1.945,1.945,0,0,1,2.752,0l1.6,1.6A1.956,1.956,0,0,1,18.793,4.924Zm0,0"
        transform="translate(-0.188)"
      />
    </svg>
  );
}

export { EditIcon };
